import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { selectCookie, selectRequestData } from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { CategoryName } from "../Discovery";
import KPILibraryItem from "./KPILibraryItem";
import { setCookie } from "../../store/actions/cookies";
import { KPI_LIBRARY_COOKIE_NAME } from "./KPILibrary";
import GroupCollapse from "../GroupCollapse";

const KPILibraryGroup = ({
  categoryCode,
  kpiLibrary,
  collapsed,
  onAdd,
  data,
  setCookie,
  searchTerm
}) => {
  const [groupKPIs, setGroupKPIs] = useState([]);

  useEffect(() => {
    const filteredKPIs = ((kpiLibrary && kpiLibrary.items) || []).filter(
      (kpi) => kpi.categoryCode === categoryCode
    );

    setGroupKPIs(filteredKPIs);
  }, [kpiLibrary]);

  const toggleState = () => {
    const newData = { ...data };
    newData[categoryCode] = !!collapsed;

    setCookie({
      name: KPI_LIBRARY_COOKIE_NAME,
      value: JSON.stringify(newData)
    });
  };

  const renderContents = () => {
    return groupKPIs.map((kpi) => {
      return (
        <KPILibraryItem
          key={kpi.code}
          kpi={kpi}
          onAdd={() => onAdd(kpi.code)}
          searchTerm={searchTerm}
        />
      );
    });
  };

  return (
    <Container data-cy={`kpi-library-group-${categoryCode}`}>
      <GroupCollapse
        title={<CategoryName categoryCode={categoryCode} />}
        onCollapse={toggleState}
        collapsed={collapsed}
      >
        {renderContents()}
      </GroupCollapse>
    </Container>
  );
};

const Container = styled.div`
  & h3,
  & h4 {
    margin-bottom: 8px;
  }
`;

KPILibraryGroup.propTypes = {
  categoryCode: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => {
  const jsonString = selectCookie(state, KPI_LIBRARY_COOKIE_NAME) || "{}";
  const data = JSON.parse(jsonString);

  return {
    kpiLibrary: selectRequestData(state, actionTypes.GET_KPI_LIBRARY_REQUEST),
    collapsed: data[props.categoryCode] !== true,
    data
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setCookie
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  KPILibraryGroup
);
